import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { UserTypeService } from '../user-type.service';
import { NAVIGATION_ROUTES } from '@shared/constants';

/**
 * Guard que protege rutas específicas de Maestro
 * Redirige a /owner/inicio si el usuario es owner
 */
export const maestroGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const userTypeService = inject(UserTypeService);

  // Verificar autenticación primero
  if (!auth.isAuthenticated()) {
    const isBrowser = typeof window !== 'undefined' && typeof location !== 'undefined';
    const currentUrl = isBrowser ? location.pathname : (router.url || NAVIGATION_ROUTES.ROOT);
    router.navigate([NAVIGATION_ROUTES.LOGIN], { queryParams: { r: currentUrl }});
    return false;
  }

  // Verificar tipo de usuario
  const userType = userTypeService.getUserType();
  
  if (userType === 'maestro') {
    return true;
  }

  // Si es owner, redirigir a su home
  if (userType === 'owner') {
    router.navigate([NAVIGATION_ROUTES.OWNER_INICIO]);
    return false;
  }

  // Si no se puede determinar, permitir acceso (compatibilidad hacia atrás)
  // TODO: Ajustar según la lógica de negocio
  return true;
};
